import { useState } from 'react';
import { Link } from 'react-router-dom';
import { NAV_LINKS } from '../constants/content';
import { SITE_NAME } from '../constants/site';

export default function TopNav() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <div className="brandbar">
        <div className="brandbar__inner shell">
          <Link className="brandbar__logo" to="/" onClick={() => setMenuOpen(false)}>
            <span className="brandbar__slash" aria-hidden="true" />
            <span className="brandbar__name">{SITE_NAME}</span>
          </Link>

          <button
            type="button"
            className="brandbar__menu-btn"
            aria-expanded={menuOpen}
            aria-controls="site-nav"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span className="visually-hidden">{menuOpen ? 'Close menu' : 'Open menu'}</span>
            <span className={`brandbar__menu-icon${menuOpen ? ' is-open' : ''}`} aria-hidden="true">
              <span />
              <span />
              <span />
            </span>
          </button>
        </div>
      </div>

      <nav
        id="site-nav"
        className={`linkbar${menuOpen ? ' is-open' : ''}`}
        aria-label="Primary"
      >
        <ul className="shell">
          {NAV_LINKS.map((link) => (
            <li key={link.label}>
              <Link to={link.href} onClick={() => setMenuOpen(false)}>
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}
